import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { PageContext } from '@context/page';

import { PagesListItem } from './pages-list-item';

interface PagesListProps extends HTMLAttributes<HTMLUListElement> {}

const UnstyledPagesList: FunctionComponent<PagesListProps> = (props) => {
  const { pages } = useContext(PageContext);

  return (
    <ul
      {...props}
      className={classNames({
        'page-list': true,
        [`${props?.className}`]: !!props?.className
      })}
    >
      {pages.map((page, index) => {
        const { createdAt, deletedAt, updatedAt, position } = page;
        if (deletedAt) return null;
        // this key forces re-render on drag, drop, and save
        const key = `${page.key}-${createdAt}-${updatedAt}-${position}-${index}`;
        return <PagesListItem page={page} key={key} />;
      })}
    </ul>
  );
};

const StyledPagesList = styled(UnstyledPagesList)`
  list-style: none;
  max-height: calc(100vh - 78px - 55px - 50px);
  margin: 0;
  overflow-y: auto;
  padding: 15px;

  .has-scrolled & {
    max-height: calc(100vh - 55px - 50px);
  }
`;

export const PagesList: FunctionComponent<PagesListProps> = (props) => {
  return <StyledPagesList {...props} />;
};
